<div
  class="input-group priceContainer"
  *ngIf="
    ((selectedStore$ | async) || (selectedStorePublic$ | async)) &&
    priceFormControl
  "
>
  <input
    type="text"
    class="form-control d-none"
    [formControl]="priceFormControl"
  />
  <form [formGroup]="priceInputForm">
    <div class="d-flex w-100">
      <span
        class="my-2 mr-2 ml-0"
        *ngIf="currencyPosition == 0 && showCurrencySymbol"
        >{{ selectedStoreCurrencySymbol }}</span
      >
      <input
        type="text"
        class="form-control"
        [class.is-invalid]="
          getControl('priceVal').invalid &&
          (getControl('priceVal').dirty || getControl('priceVal').touched)
        "
        placeholder="00"
        autocomplete="off"
        formControlName="priceVal"
        id="priceVal"
        [attr.data-testid]="priceTestId ? priceTestId + '-price' : null"
        maxlength="7"
        (input)="emitDataOnUpdateValue($event)"
        [readOnly]="readonly"
        (focus)="onInputFocus($event)"
      />
      <strong class="m-2">{{ priceSeparator }}</strong>
      <input
        type="text"
        class="form-control"
        [class.is-invalid]="
          getControl('priceDecimalVal').invalid &&
          (getControl('priceDecimalVal').dirty ||
            getControl('priceDecimalVal').touched)
        "
        placeholder="00"
        autocomplete="priceDecimalVal"
        formControlName="priceDecimalVal"
        id="priceDecimalVal"
        [attr.data-testid]="priceTestId ? priceTestId + '-decimal' : null"
        maxlength="2"
        (input)="emitDataOnUpdateValue($event)"
        [readOnly]="readonly"
        (focus)="onInputFocus($event)"
      />
      <span class="m-2" *ngIf="currencyPosition != 0 && showCurrencySymbol">{{
        selectedStoreCurrencySymbol
      }}</span>
    </div>
    <div
      class="invalid-feedback"
      *ngIf="!hideErrors && getControl('priceVal').errors"
    >
      <span *ngIf="shouldShowRequiredError('priceVal')">{{
        'admin.global.field.required' | translate
      }}</span>
      <span *ngIf="getControl('priceVal').errors.pattern">{{
        'admin.global.validate.amountNumbers' | translate
      }}</span>
      <span *ngIf="getControl('priceVal').errors.maxlength">{{
        'admin.global.field.maxLength' | translate: { maxLength: '128' }
      }}</span>
    </div>
    <div
      class="invalid-feedback"
      *ngIf="!hideErrors && getControl('priceDecimalVal').errors"
    >
      <span *ngIf="shouldShowRequiredError('priceDecimalVal')">{{
        'admin.global.field.required' | translate
      }}</span>
      <span *ngIf="getControl('priceDecimalVal').errors.pattern">{{
        'admin.global.validate.amountNumbers' | translate
      }}</span>
      <span *ngIf="getControl('priceDecimalVal').errors.maxlength">{{
        'admin.global.field.maxLength' | translate: { maxLength: '4' }
      }}</span>
    </div>
  </form>
</div>
